/**
 * Forces MSAL to invalidate any stale state
 */
export function removeActiveInteractionState() {
  sessionStorage.removeItem('msal.interaction.status');
}
